import { render, staticRenderFns } from "./MainTabBar.vue?vue&type=template&id=9af2e3f8&scoped=true&"
import script from "./MainTabBar.vue?vue&type=script&lang=js&"
export * from "./MainTabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af2e3f8",
  null
  
)

export default component.exports